import React from "react";
import { Route, Routes, Navigate } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import ProtectedLayout from "./ProtectedLayout";
import {
  SuperAdminLayout,
  CenterAdminLayout,
  SharedAdminLayout,
} from "./ProtectedLayout";
import Error401 from "../pages/error/error-401";
import LockScreenCheck from "../auth/lockscreen/LockScreenCheck";

const ALLRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Wrap all routes with LockScreenCheck to prevent navigation when screen is locked */}
      <Route element={<LockScreenCheck />}>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/unauthorized" element={<Error401 />} />

        {/* Public Routes */}
        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedLayout />}>
          <Route element={<Feature />}>
            {/* Common routes for all authenticated users */}
            {publicRoutes
              .filter((r) => !r.allowedRoles)
              .map((route, idx) => (
                <Route key={idx} path={route.path} element={route.element} />
              ))}

            {/* Routes accessible by both superadmin and centeradmin */}
            <Route element={<SharedAdminLayout />}>
              {publicRoutes
                .filter(
                  (r) =>
                    r.allowedRoles?.includes("superadmin") &&
                    r.allowedRoles?.includes("centeradmin")
                )
                .map((route, idx) => (
                  <Route key={idx} path={route.path} element={route.element} />
                ))}
            </Route>

            {/* Super Admin specific routes */}
            <Route element={<SuperAdminLayout />}>
              {publicRoutes
                .filter(
                  (r) =>
                    r.allowedRoles?.includes("superadmin") &&
                    !r.allowedRoles?.includes("centeradmin")
                )
                .map((route, idx) => (
                  <Route key={idx} path={route.path} element={route.element} />
                ))}
            </Route>

            {/* Center Admin specific routes */}
            <Route element={<CenterAdminLayout />}>
              {publicRoutes
                .filter(
                  (r) =>
                    r.allowedRoles?.includes("centeradmin") &&
                    !r.allowedRoles?.includes("superadmin")
                )
                .map((route, idx) => (
                  <Route key={idx} path={route.path} element={route.element} />
                ))}
            </Route>
          </Route>
        </Route>

        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Route>
    </Routes>
  );
};

export default ALLRoutes;
